module.exports = __webpack_public_path__ + "frontend/images/about/map.png?9e81455acd550a25811bed6b0f57af97";